module.exports = __webpack_public_path__ + "img/電気回路_3_8_1.78c5993f.png";